import type { Lang, LorsCopy } from "./translations";

export type Dec17Headline = { headline: string; subhead: string };

export const dec17Headlines: Dec17Headline[] = [
  {
    headline: "You Built the Life — Now Make Sure Your Family Doesn't Lose Months in Court Claiming It",
    subhead:
      "Join attorney Ruby Steinbrecher on December 17th for a one-hour session on wills, trusts, and California probate.",
  },
  {
    headline: "Good Intentions Don't Skip Probate — But the Right Plan Does",
    subhead:
      "Free webinar on December 17th. Learn how California families use trusts to keep their homes out of probate court.",
  },
  {
    headline: "What a Will Can't Do for Your Family — and What a Trust Can",
    subhead:
      "Attorney Ruby Steinbrecher explains the difference between wills and living trusts. Free webinar, December 17th.",
  },
  {
    headline: "The Most Expensive Mistake in California? Thinking a Will Is Enough",
    subhead:
      "Find out why a will alone may still send your family through probate. Free webinar on December 17th.",
  },
  {
    headline: "Probate Fees on a Sonoma County Home Can Hit Five Figures — Here's Why",
    subhead:
      "We'll break down California probate costs and how a funded trust can protect your home. December 17th.",
  },
  {
    headline: "Keep Your Home in the Family — Without the Courthouse",
    subhead:
      "Probate can tie up your home for months. Join our free webinar on December 17th to learn how to avoid it.",
  },
  {
    headline: "Grief Is Hard Enough Without Adding Paperwork, Deadlines, and Court Dates",
    subhead:
      "Join attorney Ruby Steinbrecher on December 17th and learn how to make your plan easier on the people you love.",
  },
  {
    headline: "Wills, Trusts, or Both? Get Clear Answers in One Hour",
    subhead:
      "Reserve your spot for the free estate planning webinar on December 17th. No pressure, just clear information.",
  },
  {
    headline: "Your Plan Might Be Outdated. Here's How to Tell.",
    subhead:
      "Laws change and families change. Join us on December 17th for a free session on reviewing and updating your plan.",
  },
  {
    headline: "One Hour Now Could Save Your Family a Year in Court",
    subhead:
      "A practical, no-pressure estate planning session on December 17th with attorney Ruby Steinbrecher.",
  },
];

const baseEn = {
  eyebrow: "Free Estate Planning Webinar",
  headline: dec17Headlines[0].headline,
  headlineBreakBefore: "",
  subhead: dec17Headlines[0].subhead,
  subheadLabel: "A note from Ruby:",
  learnTitle: "What Most Families Don't Realize Until It's Too Late",
  learnItems: [
    "How wills, living trusts, and powers of attorney each work in California",
    "How a properly funded living trust can help a family pass assets without probate court",
    "What California's probate process generally looks like — timelines, court involvement, and typical costs",
    "Practical first steps for putting an estate plan in place, and the questions to ask before you do",
  ],
  quote:
    "Ruby Steinbrecher was fantastic. The family trust workshop was clear, informative, and extremely helpful for getting started with estate planning.",
  quoteAttribution: "Shawn H., Workshop Attendee",
  formDate: { short: "Thu, December 17th", long: "Thursday, December 17th" },
  formTime: "12:00 PM PT",
  formVenueLine1: "Live Online Webinar",
  formVenueLine2: "Join from anywhere — link sent after registration",
  formTitle: "Reserve Your Seat",
  formSubtitle: "Free to attend. Limited seating available.",
  formFirstName: "First name",
  formLastName: "Last name",
  formEmail: "Email",
  formPhone: "Phone",
  formSmsConsent:
    "I consent to receive text messages from the Law Office of Ruby Steinbrecher about this event, and occasional marketing messages. Message & data rates may apply. Text HELP for assistance, reply STOP to opt out.",
  formEnewsConsent:
    "I'd like to receive occasional email updates from the Law Office of Ruby Steinbrecher.",
  formPrivacy: "Privacy Policy",
  formSubmit: "Reserve My Seat",
  formSubmitting: "Reserving your seat…",
  formTrust: "⭐ Trusted by local families | 81 Five-Star Reviews",
  getDirections: "",
  footerCopyright: "© 2026 Ruby Steinbrecher",
  footerPrivacy: "Privacy Policy",
  testimonialsTitle: "What Families Are Saying",
  aboutTitle: "Meet Ruby Steinbrecher",
  aboutRole: "Attorney",
  aboutBody: [
    "I have practiced law since 2007, first working at a medium-sized firm in San Francisco handling civil litigation, and then moving into estate planning, small business and contract law since 2010. I value people, the planet, and prosperity that does not adversely affect the former.",
    "Prior to entering the legal field, I had a variety of business and life experience that has only enhanced my ability to serve clients: Road Manager for Ken Kesey\'s bus trip to Great Britain in 1999, Human Resources at a tech startup in 2001, recognized for my work as a Case Manager at Casey Family Programs with disadvantaged youth in the foster care system in Oakland and the wider San Francisco-Bay Area in the early 2000\'s.",
    "Currently, I live in Sebastopol with my daughter, husband, and a menagerie of pets, where I enjoy gardening as it keeps me grounded and enjoying the beautiful weather.",
  ],
  registrationTitle: "Ready to Secure Your Family's Future?",
  registrationSub: "Free to attend. Limited seating available.",
  registrationCta: "Save My Seat",
  registrationFoot:
    "No pressure. Just clear information so you can make the right decision for your family.",
  errorTitle: "Something went wrong",
  errorBody:
    "We couldn't reserve your seat. Please try again or call our office.",
  validation: {
    firstName: "First name is required",
    lastName: "Last name is required",
    email: "Enter a valid email",
    phone: "Enter a valid phone number",
  },
  timeAgo: {
    monthAgo: "a month ago",
    monthsAgo: (n: number) => `${n} months ago`,
    yearAgo: "a year ago",
  },
};

export const lorsContentDec17 = { en: baseEn, es: baseEn } as unknown as Record<Lang, LorsCopy>;

export const getDec17Copy = (hParam: string | null): LorsCopy => {
  const n = Number(hParam);
  const idx = Number.isInteger(n) && n >= 1 && n <= dec17Headlines.length ? n - 1 : 0;
  const pick = dec17Headlines[idx];
  return { ...baseEn, headline: pick.headline, subhead: pick.subhead } as unknown as LorsCopy;
};
